(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}
connectedCallback() {
this.header = document.querySelector('.section-header');
this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
this.headerBounds = {};
this.setHeaderHeight();
window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
if (this.headerIsAlwaysSticky) {
this.header.classList.add('shopify-section-header-sticky');
};
this.currentScrollTop = 0;
this.preventReveal = false;
this.predictiveSearch = this.querySelector('predictive-search');
this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => this.preventReveal = true;
this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);
this.createObserver();
}
setHeaderHeight() {
document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
}
disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}
createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});
observer.observe(this.header);
}
onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
this.header.classList.add('scrolled-past-header');
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
this.header.classList.add('scrolled-past-header');
if (!this.preventReveal) {
requestAnimationFrame(this.reveal.bind(this));
} else {
window.clearTimeout(this.isScrolling);
this.isScrolling = setTimeout(() => {
this.preventReveal = false;
}, 66);
requestAnimationFrame(this.hide.bind(this));
}
} else if (scrollTop <= this.headerBounds.top) {
this.header.classList.remove('scrolled-past-header');
requestAnimationFrame(this.reset.bind(this));
}
this.currentScrollTop = scrollTop;
}
hide() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
this.closeMenuDisclosure();
this.closeSearchModal();
}
reveal() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.remove('shopify-section-header-hidden');
}
reset() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}
closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
this.disclosures.forEach(disclosure => disclosure.close());
}
closeSearchModal() {
this.searchModal = this.searchModal || this.header.querySelector('details-modal');
this.searchModal.close(false);
}
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["patner-testimonial"] && !Shopify.designMode) return;
  try {
    
   $(document).ready(function () {
  $('.patner-testimonial').slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    prevArrow: `<button type="button" class="slick-prev">
     <svg xmlns="http://www.w3.org/2000/svg" width="49" height="50" viewBox="0 0 49 50" fill="none">
  <g clip-path="url(#clip0_120_3206)">
    <circle cx="24.5" cy="24.5" r="24.5" transform="matrix(-1 0 0 1 49 0.535156)" fill="#6B3C0E"/>
    <path d="M17.6474 26.5174L28.2741 36.8494C28.5736 37.1406 28.9797 37.3042 29.4032 37.3042C29.8267 37.3042 30.2329 37.1406 30.5323 36.8494C30.8318 36.5583 31 36.1634 31 35.7517C31 35.3399 30.8318 34.945 30.5323 34.6539L21.0333 25.4209L30.5297 16.1854C30.6779 16.0413 30.7956 15.8701 30.8758 15.6818C30.956 15.4934 30.9973 15.2915 30.9973 15.0876C30.9973 14.8838 30.956 14.6819 30.8758 14.4935C30.7956 14.3052 30.6779 14.134 30.5297 13.9899C30.3814 13.8457 30.2054 13.7314 30.0116 13.6533C29.8179 13.5753 29.6103 13.5352 29.4006 13.5352C29.1909 13.5352 28.9832 13.5753 28.7895 13.6533C28.5958 13.7314 28.4198 13.8457 28.2715 13.9899L17.6448 24.3219C17.4963 24.466 17.3786 24.6373 17.2984 24.8257C17.2182 25.0142 17.177 25.2162 17.1772 25.4202C17.1775 25.6242 17.2192 25.8261 17.2998 26.0144C17.3805 26.2027 17.4986 26.3736 17.6474 26.5174Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_120_3206">
      <rect width="49" height="49" fill="white" transform="matrix(-1 0 0 1 49 0.535156)"/>
    </clipPath>
  </defs>
</svg>
    </button>`,
    nextArrow: `<button type="button" class="slick-next">
      <svg xmlns="http://www.w3.org/2000/svg" width="49" height="50" viewBox="0 0 49 50" fill="none">
        <g clip-path="url(#clip0_120_3205)">
            <circle cx="24.5" cy="25.0352" r="24.5" fill="#6B3C0E"/>
            <path d="M31.3526 26.5174L20.7259 36.8494C20.4264 37.1406 20.0203 37.3042 19.5968 37.3042C19.1733 37.3042 18.7671 37.1406 18.4677 36.8494C18.1682 36.5583 18 36.1634 18 35.7517C18 35.3399 18.1682 34.945 18.4677 34.6539L27.9667 25.4209L18.4703 16.1854C18.3221 16.0413 18.2044 15.8701 18.1242 15.6818C18.044 15.4934 18.0027 15.2915 18.0027 15.0876C18.0027 14.8838 18.044 14.6819 18.1242 14.4935C18.2044 14.3052 18.3221 14.134 18.4703 13.9899C18.6186 13.8457 18.7946 13.7314 18.9884 13.6533C19.1821 13.5753 19.3897 13.5352 19.5994 13.5352C19.8091 13.5352 20.0168 13.5753 20.2105 13.6533C20.4042 13.7314 20.5802 13.8457 20.7285 13.9899L31.3552 24.3219C31.5037 24.466 31.6214 24.6373 31.7016 24.8257C31.7818 25.0142 31.823 25.2162 31.8228 25.4202C31.8225 25.6242 31.7808 25.8261 31.7002 26.0144C31.6195 26.2027 31.5014 26.3736 31.3526 26.5174Z" fill="white"/>
        </g>
        <defs>
            <clipPath id="clip0_120_3205">
            <rect width="49" height="49" fill="white" transform="translate(0 0.535156)"/>
            </clipPath>
        </defs>
        </svg>
    </button>`,
     responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.4,
        infinite: false
      }
    }
  ]
  });
});

    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["radiant-slider"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    $('.radiant-slider-wrapper').slick({
      dots: true,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1
    });

    // Play video on click
    $('.play-button, .video-thumbnail').on('click', function(){
      var container = $(this).closest('.video-container');
      var video = container.find('.video-element')[0];
      container.find('.video-thumbnail, .play-button').hide();
      $(video).show();
      video.play();
    });
  });

  $('.radiant-slider-wrapper').on('afterChange', function(event, slick, currentSlide){
  var slider = $('.radiant-slider');

  slider.removeClass('style-yellow style-red style-purple style-green');

  if(currentSlide === 0){
    slider.addClass('style-yellow');
  } else if(currentSlide === 1){
    slider.addClass('style-red');
  } else if(currentSlide === 2){
    slider.addClass('style-purple');
  } else if(currentSlide === 3){
    slider.addClass('style-green');
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["realpeople-section"] && !Shopify.designMode) return;
  try {
    
   $(document).ready(function () {
  $('.testimonial-slider').slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    prevArrow: `<button type="button" class="slick-prev">
      <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none">
        <g clip-path="url(#clip0_4169_3789)">
          <circle cx="24.5" cy="24.5" r="24.5" transform="matrix(-1 0 0 1 49 0)" fill="#375241"/>
          <path d="M17.6474 25.9823L28.2741 36.3143C28.5736 36.6054 28.9797 36.769 29.4032 36.769C29.8267 36.769 30.2329 36.6054 30.5323 36.3143C30.8318 36.0231 31 35.6283 31 35.2165C31 34.8048 30.8318 34.4099 30.5323 34.1187L21.0333 24.8858L30.5297 15.6503C30.6779 15.5061 30.7956 15.335 30.8758 15.1466C30.956 14.9582 30.9973 14.7564 30.9973 14.5525C30.9973 14.3486 30.956 14.1467 30.8758 13.9584C30.7956 13.77 30.6779 13.5989 30.5297 13.4547C30.3814 13.3106 30.2054 13.1962 30.0116 13.1182C29.8179 13.0402 29.6103 13 29.4006 13C29.1909 13 28.9832 13.0402 28.7895 13.1182C28.5958 13.1962 28.4198 13.3106 28.2715 13.4547L17.6448 23.7867C17.4963 23.9309 17.3786 24.1021 17.2984 24.2906C17.2182 24.479 17.177 24.6811 17.1772 24.885C17.1775 25.089 17.2192 25.2909 17.2998 25.4792C17.3805 25.6675 17.4986 25.8385 17.6474 25.9823Z" fill="white"/>
        </g>
        <defs>
          <clipPath id="clip0_4169_3789">
            <rect width="49" height="49" fill="white" transform="matrix(-1 0 0 1 49 0)"/>
          </clipPath>
        </defs>
      </svg>
    </button>`,
    nextArrow: `<button type="button" class="slick-next">
      <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none">
        <g clip-path="url(#clip0_4169_3786)">
          <circle cx="24.5" cy="24.5" r="24.5" fill="#375241"/>
          <path d="M31.3526 25.9823L20.7259 36.3143C20.4264 36.6054 20.0203 36.769 19.5968 36.769C19.1733 36.769 18.7671 36.6054 18.4677 36.3143C18.1682 36.0231 18 35.6283 18 35.2165C18 34.8048 18.1682 34.4099 18.4677 34.1187L27.9667 24.8858L18.4703 15.6503C18.3221 15.5061 18.2044 15.335 18.1242 15.1466C18.044 14.9582 18.0027 14.7564 18.0027 14.5525C18.0027 14.3486 18.044 14.1467 18.1242 13.9584C18.2044 13.77 18.3221 13.5989 18.4703 13.4547C18.6186 13.3106 18.7946 13.1962 18.9884 13.1182C19.1821 13.0402 19.3897 13 19.5994 13C19.8091 13 20.0168 13.0402 20.2105 13.1182C20.4042 13.1962 20.5802 13.3106 20.7285 13.4547L31.3552 23.7867C31.5037 23.9309 31.6214 24.1021 31.7016 24.2906C31.7818 24.479 31.823 24.6811 31.8228 24.885C31.8225 25.089 31.7808 25.2909 31.7002 25.4792C31.6195 25.6675 31.5014 25.8385 31.3526 25.9823Z" fill="white"/>
        </g>
        <defs>
          <clipPath id="clip0_4169_3786">
            <rect width="49" height="49" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    </button>`
  });
});

    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skin-journey-collections"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    function initMobileSlider(){
      var $slider = $('.skin-journey-slider');
      if ($(window).width() < 769) {
        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick({
            slidesToShow: 1.5,
            dots: true,
            arrows: false,
            infinite: false
          });
        }
      } else {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
      }
    }

    initMobileSlider();
    $(window).on('resize orientationchange', function(){
      initMobileSlider();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
